import { defineMessages } from 'react-intl';

export default defineMessages({
    accountInformation: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Account Information',
        defaultMessage: 'Account Information',
    },
    issueSavingDetails: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Issue saving details, please try again',
        defaultMessage: 'Issue saving details, please try again',
    },
    accountDetails: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Account Details',
        defaultMessage: 'Account Details',
    },
    accountTitleWithInForcePolicies: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Account Details:',
        defaultMessage: 'Account Details: {accountName} ({accountNumber})',
    },
    accountTitleWithNoInForcePolicies: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Below are the details of the account that has no active policies',
        defaultMessage:
            'Below are the details of the account that has no active policies',
    },
    billingDetails: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Billing Details',
        defaultMessage: 'Billing Details',
    },
    billingEqualAddress: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Is your Billing Address the same as the one above?',
        defaultMessage: 'Is your Billing Address the same as the one above?',
    },
    billingIsTheSame: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Your billing address is the same.',
        defaultMessage: 'Your billing address is the same.',
    },
    billingDelivery: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Billing Delivery',
        defaultMessage: 'Billing Delivery',
    },
    deliveryMethod: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Delivery Method',
        defaultMessage: 'Delivery Method',
    },
    sentByMail: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Sent in the mail',
        defaultMessage: 'Sent in the mail',
    },
    sentByEmail: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Sent by email',
        defaultMessage: 'Sent by email',
    },
    applyToAllAccountsTitle: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Apply Contact Details to Other Policies',
        defaultMessage: 'Apply Contact Details to Other Policies',
    },
    applyToAllAccounts: {
        id: 'twia-tfpa.usersprofile.directives.templates.user-details-apply-to-all.Do you want to use these contact details for policies that belong to other accounts?',
        defaultMessage:
            'Do you want to use these contact details for policies that belong to other accounts?',
    },
    applyToAllAccountsYes: {
        id: 'twia-tfpa.usersprofile.directives.templates.user-details-apply-to-all.Yes',
        defaultMessage: 'Yes',
    },
    applyToAllAccountsNo: {
        id: 'twia-tfpa.usersprofile.directives.templates.user-details-apply-to-all.No',
        defaultMessage: 'No',
    },
    cancel: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Save',
        defaultMessage: 'Save',
    },
    cancelEditTitle: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Cancel contact information update',
        defaultMessage: 'Cancel contact information update',
    },
    cancelEditMessage: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Are you sure you want to cancel your account contact profile changes?',
        defaultMessage:
            'Are you sure you want to cancel your account contact profile changes?',
    },
    inValidPaperlessTitle: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Invalid Paperless Billing Settings',
        defaultMessage: 'Invalid Paperless Billing Settings',
    },
    inValidPaperlessMessage: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.A valid email address is required for paperless billing',
        defaultMessage:
            'A valid email address is required for paperless billing',
    },
    accountSettings: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Account Settings',
        defaultMessage: 'Account Settings',
    },
    accountLanguage: {
        id: 'twia-tfpa.usersprofile.views.amp-users-profile.Language',
        defaultMessage: 'Language',
    },
    accountTitleWithNumber: {
        id: 'twia.twia-tfpa.usersprofile.views.amp-users-profile.Account Title',
        defaultMessage: 'Account {accountNumber}',
    },
    accountTitleWithNumberInforcePolicies: {
        id: 'twia.twia-tfpa.usersprofile.views.amp-users-profile.Account Inforce',
        defaultMessage: 'Below are the account details for the following policies: {policyNumbers}',
    },
    accountTitleWithNumberNoInforcePolicies: {
        id: 'twia.twia-tfpa.usersprofile.views.amp-users-profile.Account No Inforce',
        defaultMsseage: 'Below are the details of the account that has no active policies',
    },
    emailInvalidTitle: {
        id: 'twia.twia-tpaf.userprofile.views.amp-user-profile.Invalid Email',
        defaultMessage: 'Invalid Email'
    },
    emailInvalidMessage: {
        id: 'twia.twia-tpaf.userprofile.views.amp-user-profile.Email Invalid Message',
        defaultMessage: 'Must be the policyholder\'s email address and cannot be one registered with your organization.'
    }
});
